module.exports = __webpack_public_path__ + "static/media/win.4ce7768f.png";